/* <cart-drawer> — sepet çekmecesi: aç/kapat + AJAX sepete ekle. Satır/indirim/not mantığı: cart-items.js (CPL.CartItems) */
if (!customElements.get('cart-drawer') && window.CPL && CPL.CartItems) {
  class CartDrawer extends CPL.CartItems {
    constructor() {
      super();
      this.contentId = 'CartDrawer-Content';
      this.source = 'cart-drawer';
      this.scrollSelector = '.drawer__body';
    }

    connectedCallback() {
      super.connectedCallback();
      this.panel = this.querySelector('.drawer__panel');
      // Esc: odak çekmece dışında kalsa bile kapat
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          e.preventDefault();
          this.close();
        }
      });
    }

    get isOpen() {
      return this.classList.contains('is-open');
    }

    open(opener) {
      if (this.isOpen) return;
      // Açık modal (ör. hızlı bakış) varsa önce kapat; kapanırken odak tuzağını kaldırmasın diye sonra kendi tuzağımızı kur
      const modal = document.querySelector('modal-dialog:not([hidden])');
      if (modal) {
        this.opener = modal.opener || null;
        modal.close({ restoreFocus: false });
      } else {
        this.opener = opener || document.activeElement;
      }
      this.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
      CPL.trapFocus(this.panel, this.querySelector('[data-cart-close][data-focus="close"]') || this.panel);
    }

    close() {
      if (!this.isOpen) return;
      this.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
      const opener = this.opener && document.contains(this.opener) ? this.opener : null;
      CPL.removeTrapFocus(opener);
      this.opener = null;
    }

    onClick(e) {
      if (e.target.closest('[data-cart-close]')) {
        e.preventDefault();
        this.close();
        return true;
      }
      return super.onClick(e);
    }

    focusFallback() {
      return this.content?.querySelector('[data-focus="close"]');
    }
  }
  customElements.define('cart-drawer', CartDrawer);

  /* Header sepet butonu ([data-cart-open]) */
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (!opener) return;
    // Sepet sayfasındayken çekmece açma, sayfa başına kaydır
    const page = document.querySelector('cart-page');
    if (page) {
      e.preventDefault();
      if (typeof page.reveal === 'function') page.reveal();
      return;
    }
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || (window.cplSettings && window.cplSettings.cartType === 'page')) return;
    e.preventDefault();
    drawer.open(opener);
  });

  // Toast için küçük görsel adresi
  const thumb = (src) => {
    if (!src) return null;
    try {
      const u = new URL(src, window.location.origin);
      u.searchParams.set('width', '96');
      return u.toString();
    } catch (err) {
      return src;
    }
  };

  /* AJAX sepete ekle: form[action$="/cart/add"][data-cart-ajax] */
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[action$="/cart/add"][data-cart-ajax]')) return;
    e.preventDefault();

    const drawer = document.querySelector('cart-drawer');
    const fromDrawer = !!(drawer && drawer.contains(form));
    const btn = e.submitter || form.querySelector('[type="submit"]');
    if (btn) {
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
    }

    const fd = new FormData(form);
    const item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 };
    if (fd.get('selling_plan')) item.selling_plan = fd.get('selling_plan');
    const properties = {};
    for (const [k, v] of fd.entries()) {
      const m = k.match(/^properties\[(.+)\]$/);
      if (m && v !== '') properties[m[1]] = v;
    }
    if (Object.keys(properties).length) item.properties = properties;

    try {
      const { data } = await CPL.cart.add([item], 'product-form');
      if (fromDrawer) return; // çekmece zaten açık, içerik yenilendi
      const type = (window.cplSettings && window.cplSettings.cartType) || 'drawer';
      const onCartPage = !!document.querySelector('cart-page');
      if (onCartPage) {
        // Sepet sayfası zaten yenilendi; çekmece açmadan kısa bildirim
        const added = (data.items && data.items[0]) || data;
        const base = (window.cplStrings && window.cplStrings.addedToCart) || '';
        CPL.toast({ type: 'success', text: added.product_title ? `${base} · ${added.product_title}` : base, image: thumb(added.image) });
      } else if (type === 'page' || !drawer) {
        window.location.href = window.routes.cart_url;
      } else if (type === 'notification') {
        const added = (data.items && data.items[0]) || data;
        const base = (window.cplStrings && window.cplStrings.addedToCart) || '';
        CPL.toast({ type: 'cart', text: added.product_title ? `${base} · ${added.product_title}` : base, image: thumb(added.image) });
      } else {
        drawer.open(btn && document.contains(btn) ? btn : null);
      }
    } catch (err) {
      CPL.toast({
        type: 'error',
        text: (err && (err.description || err.message)) || (window.cplStrings && window.cplStrings.cartError) || '',
      });
    } finally {
      if (btn) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      }
    }
  });
}
